import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import * as reportSelectors from '../../selectors/reportSelectors';
import * as organizationSelectors from '../../selectors/organizationSelectors';
import * as organizationConstants from '../../constants/organizations';

import DateSelector from '../../components/report/DateSelector';
import Report from '../../components/report/Report';
import Export from '../../components/report/Export';

const OrganizationReport = ({
    location,
    organizationId,
    generateReport,
    data,
    header,
    loading,
    onDownloadReport,
    isOrganizationAdmin,
    classes,
}) => {
    if (!isOrganizationAdmin) {
        return null;
    }

    const params = new URLSearchParams(location.search);
    const start = params.get('start');
    const end = params.get('end');

    return (
        <div className={classes.wrapper}>
            <DateSelector
                organizationId={organizationId}
                start={start}
                end={end}
                generateReport={generateReport}
            />
            <div className={classes.report}>
                <Report header={header} data={data} loading={loading} />
                <div className={classes.actions}>
                    <Export
                        start={start}
                        end={end}
                        organizationId={organizationId}
                        loading={loading}
                        onDownloadReport={onDownloadReport}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    data: reportSelectors.getData(state),
    header: reportSelectors.getHeader(state),
    loading: reportSelectors.getLoading(state),
    organizationId: organizationSelectors.getCurrentOrganizationId(state),
    isOrganizationAdmin: organizationSelectors.getIsCurrentUserAdminForOrganization(
        state,
    ),
});

const mapDispatchToProps = dispatch => ({
    generateReport: payload =>
        dispatch({ type: organizationConstants.REPORT_REQUEST, payload }),
    onDownloadReport: payload =>
        dispatch({
            type: organizationConstants.DOWNLOAD_REPORT_REQUEST,
            payload,
        }),
});

OrganizationReport.propTypes = {
    data: PropTypes.array.isRequired,
    header: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    organizationId: PropTypes.number.isRequired,
    generateReport: PropTypes.func.isRequired,
    onDownloadReport: PropTypes.func.isRequired,
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    report: {
        width: '100%',
        maxWidth: spacing.maxWidth,
        marginTop: spacing.unit * 6,
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(OrganizationReport));



// WEBPACK FOOTER //
// ./src/containers/organizationReport/OrganizationReport.js